import { addDays, format } from 'date-fns';

import { multiSelectorOptionsMapper, optionsMapper } from '../utils';

const rangeOptions: Array<{ label: string, value: ['from' | 'to', Date]}> = [
  { label: 'Em 5 dias', value: ['to', addDays(new Date(), 5) ] },
  { label: 'Em 10 dias', value: ['to', addDays(new Date(), 10) ] },
  { label: 'Em 15 dias', value: ['to', addDays(new Date(), 15) ] },
  { label: 'Em 30 dias', value: ['to', addDays(new Date(), 30) ] },
  { label: 'Em 60 dias', value: ['to', addDays(new Date(), 60) ] },
  { label: 'Em 90 dias', value: ['to', addDays(new Date(), 90) ] },
  { label: 'Após 90 dias', value: ['from', addDays(new Date(), 90) ] },
];

const options = rangeOptions.map(o => {
  const [type, date] = o.value
  return {
    label: o.label,
    value: [type, format(date, 'yyyy-MM-dd')].join(':')
  }
});

export const useBlockedProductExpirationRangeOptions = () => {
  return {
    singleSelectOptions: options.map(optionsMapper),
    multiSelectOptions: options.map(multiSelectorOptionsMapper),
  }
};